export enum enumStatementState {
  CREATED = 0,
  AUTHORIZATION_PENDING = 10,
  AUTHORIZATION_SENT = 20,
  AUTHORIZATION_COMPLETED = 30,
  AUTHORIZATION_REJECTED = 40,
  CHARGED = 50,
}
